import React from 'react'
import moment from 'moment'
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  form
} from 'reactstrap';
import { Button } from 'reactstrap';
import "./noti.css"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faUserPlus,
  faDice,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faSignInAlt,
  faUserPlus,
  faDice,
  faEnvelope
);
/*<iframe width="853" height="480" src="https://www.youtube.com/embed/eq2S1dQSNFI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>*/
const Notifications = (props) => {
  const { notifications } = props;
  return (
    <div>
      <div className="noti-box">
        <div className="card-content">
          <form class="video-form"><span className="video-text">วิดีโอแนะนำ</span></form>
          <div class="video-container">
            
            <iframe width="727" height="409" src="https://www.youtube.com/embed/kq2P2tfbR_A" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <form className="bt">
            <Button className="btcircle1" href="/test">แบบทดสอบ <FontAwesomeIcon icon="dice" /></Button>
            <Button className="btcircle2" href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ <FontAwesomeIcon icon="envelope" /></Button>{' '}
          </form>

          <form class="notifi-form "><span className="noti-text">การแจ้งเตือน</span></form>
          {notifications && notifications.map(item => {
            return (
              <li className="list-stley" key={item.id}>
                <span className="pink-text">{item.user}</span>
                <span>{item.content}</span>
                <div className="green-text note-date">
                  {moment(item.time.toDate()).fromNow()}
                </div>
              </li>
            )
          })}
        </div>
       
      </div>
    </div>
  )
}

export default Notifications